import { PersonPreviewModel } from './../../../models/person/person-preview.model';
import { IPersonDetailState } from "./state.store";
import { MutationTree } from "vuex";
import PersonStoreTypes from "./define-types.store";

const mutations: MutationTree<IPersonDetailState> = <MutationTree<IPersonDetailState>>{
    [PersonStoreTypes.Set.PERSON_MODEL]: (
        state: IPersonDetailState,
        personModel: PersonPreviewModel
    ) => {
        state.personModel = personModel;
    },
};

export default mutations;
